var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.bildspel),function(bild){return _c('div',{staticClass:"slide"},[_c('div',{staticClass:"h1"},[_vm._v("\n      "+_vm._s(bild.name)+"\n    ")]),_vm._v(" "),_c('img',{attrs:{"src":bild.bild}})])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51a9823a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/routerViews/Test.vue
// module id = 9nuk
// module chunks = 0